import { fetchUtils, type Identifier } from 'react-admin';
import type { ClicksByMerchantsResource } from '../../../Entities/ClicksByMerchant';
import create from '../../create';
import type { JsonApiResource } from '../../JsonApiTypes';
import type { AuthProvider } from '../../AuthProvider';

export interface ReportClickMerchantCreateParams {
  from: string;
  to: string;
  regionIds?: number[];
  merchantIds?: number[];
}
export interface ReportClickMerchantCreateResult {
  reportId: string;
  data: ClicksByMerchantsResource[];
  prefetched: Record<string, JsonApiResource[]>;
}
export type ReportClickMerchantCreate = (
  params: ReportClickMerchantCreateParams,
) => Promise<ReportClickMerchantCreateResult>;

export default function clickMerchantCreate(
  apiUrl: string,
  httpClient = fetchUtils.fetchJson,
  canAccess: typeof AuthProvider.canAccess = async () => true,
): ReportClickMerchantCreate {
  const createRecord = create(apiUrl, httpClient);
  return async (params) => {
    const prefetch = [];

    if (await canAccess({ resource: 'clicks_by_merchants', action: 'list' })) {
      prefetch.push('results');
    }
    if (await canAccess({ resource: 'regions', action: 'list' })) {
      prefetch.push('results.region');
    }
    if (await canAccess({ resource: 'merchants', action: 'list' })) {
      prefetch.push('results.merchant');
    }
    if (await canAccess({ resource: 'merchant_statuses', action: 'list' })) {
      prefetch.push('results.merchant.merchant_status');
    }

    const result = await createRecord('reports', {
      data: {
        attributes: {
          report_type_id: 1,
          from: params.from,
          to: params.to,
          ...(params.regionIds?.length ? { region_ids: params.regionIds } : {}),
          ...(params.merchantIds?.length ? { merchant_ids: params.merchantIds } : {}),
        },
      },
      meta: {
        prefetch,
      },
    });
    const prefetched = (result.meta?.prefetched ?? {}) as Record<string, JsonApiResource[]>;
    return {
      reportId: String(result.data.id as Identifier),
      data: (prefetched.clicks_by_merchants ?? []) as ClicksByMerchantsResource[],
      prefetched,
    };
  };
}
